const attendingReasons = {
	reason01: {
		wrapper: 'col-12',
		component: 'check-input-group',
		label: 'What are your reasons for attending {show}? (Select all that apply)',
		options: [
			'To source new suppliers',
			'To see new products',
			'To place orders',
			"I'm considering exhibiting at the next event",
			'To network',
			'To keep abreast of Industry trends',
			'To see existing suppliers',
			'Other',
		],
	},
	reason01_Other: {
		conditions: {
			reason01: 'Other',
		},
		wrapper: 'col-12',
		component: 'text-input',
		label: 'Please specify',
		validationLabel: 'What are your reasons for attending {show}? Please specify',
	},
};

const numberOfEmployees = {
	employees: {
		wrapper: 'col-12',
		component: 'radio-input-group',
		label: 'Number of employees in your company?',
		options: ['Yourself', '1-5', '6-10', '11-20', '21-50', '51-100', '101+'],
	},
};

const jobStatus = {
	job_status: {
		wrapper: 'col-12',
		component: 'radio-input-group',
		label: 'Which best describes your level within your operation?',
		newEntryReset: true,
		options: ['Owner/C-level', 'General Manager', 'Manager', 'Staff', 'Junior / Intern / Student', 'Other'],
	},
	job_other: {
		conditions: {
			job_status: 'Other',
		},
		wrapper: 'col-12',
		component: 'text-input',
		label: 'Please specify',
		validationLabel: 'Which best describes your level within your operation? Please specify',
		newEntryReset: true,
	},
};

const referralSource = {
	referral_source: {
		wrapper: 'col-12',
		component: 'check-input-group',
		label: 'How did you find out about {show}? (Select all that apply)',
		newEntryReset: true,
		options: [
			'{show} e-newsletter',
			'Exhibitor e-newsletter',
			'Exhibitor invite',
			'{show} posted invitation',
			'Industry Association',
			'Trade magazine advertising',
			'Telemarketing',
			'SMS',
			'Google',
			'Online advert',
			'Facebook',
			'LinkedIn',
			'Instagram',
			'Word of mouth',
			'TikTok',
			'News article',
			'Other',
		],
	},
	referral_source_other: {
		conditions: {
			referral_source: 'Other',
		},
		wrapper: 'col-12',
		component: 'text-input',
		label: 'Please specify',
		validationLabel: 'How did you find out about {show}? Please specify',
		newEntryReset: true,
	},
};

export { attendingReasons, numberOfEmployees, jobStatus, referralSource };
